import React, {Component} from 'react';
import '../css/DealerCta.css';

class DealerCta extends Component {

	render() {
		let width = this.props.dimensions.width;
		const classes = (width >= 684 )
		? "app__dealercta-copy app__emco-wide"
		: "app__dealercta-copy";

		const ctaLink = this.props.config.env === 'dev'
			? `https://daikinatlantic.ca/${this.props.config.lang === 'en' ? '#find-a-dealer' : 'fr/#find-a-dealer'}`
			: '';

		return (<div className="app__dealercta">
			<div className={classes}>
				<div className="app__emco_col_6">
					<p className="app__responsive-wrap">{this.props.content.ctaCopy}</p>
				</div>
				<div className="app__emco_col_6">
					<p className="app__responsive-wrap">
						<a className="app__button-reset app_dealercta-link" href={ctaLink} rel="noopener noreferrer">{this.props.content.findDealer}</a>
					</p>
				</div>
			</div>
		</div>);
	}
}

export default DealerCta;



// WEBPACK FOOTER //
// ./src/components/DealerCta.js